import { http } from "msw";
import type { Cart, Product } from "../../api/types";
import { getCollection } from "../db";
import * as viewerState from "../viewer-state";
import { decorateProductSummary, mockJson, runMutation } from "./shared";

async function buildCart(): Promise<Cart> {
  const products = await getCollection<Product>("products");
  const ids = viewerState.cartProductIds();
  const items = ids
    .map((id) => products.find((p) => p.id === id))
    .filter((p): p is Product => Boolean(p))
    .map(decorateProductSummary);
  const subtotal = items.reduce((sum, item) => sum + item.price, 0);
  return { items, subtotal };
}

interface CartMutationBody {
  productId: string;
}

export const cartHandlers = [
  http.get("/api/cart", async () => mockJson(await buildCart())),

  http.post("/api/cart", async ({ request }) => {
    const { productId } = (await request.json()) as CartMutationBody;
    return runMutation(async () => {
      viewerState.addToCart(productId);
      return buildCart();
    });
  }),

  http.delete("/api/cart/:productId", async ({ params }) => {
    return runMutation(async () => {
      viewerState.removeFromCart(String(params.productId));
      return buildCart();
    });
  }),
];
